<script setup>
import { computed } from 'vue'

const props = defineProps({
  selectedMethods: {
    type: Array,
    default: () => []
  },
  allMethods: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: 'Your Selection'
  }
})

const selectedCount = computed(() => props.selectedMethods.length)
</script>

<template>
  <section id="selection-summary" class="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
    <h4 class="text-lg font-bold text-gray-900 mb-4">{{ title }}</h4>
    <div v-if="selectedCount > 0" class="space-y-3 mb-6">
      <div
        v-for="method in allMethods.filter(m => selectedMethods.includes(m.id))"
        :key="method.id"
        class="flex items-center justify-between p-3 bg-blue-50 rounded-lg"
      >
        <div class="flex items-center space-x-3">
          <span class="material-symbols-outlined text-brand">{{ method.icon_name }}</span>
          <span class="text-sm font-medium text-gray-900">{{ method.name }}</span>
        </div>
        <span class="material-symbols-outlined text-brand-blue">check</span>
      </div>
    </div>
    <div v-else class="text-center py-6 text-gray-400">
      <span class="material-symbols-outlined text-4xl mb-2 block">pending</span>
      <p class="text-sm">Nothing selected yet</p>
    </div>
    <div class="pt-4 border-t border-gray-200">
      <div class="flex items-center justify-between text-sm">
        <span class="text-gray-600">Total selected</span>
        <span class="font-bold text-gray-900">{{ selectedCount }}</span>
      </div>
    </div>
  </section>
</template>
